<template lang="pug">
  d2-container
    el-form(:model="searchForm" :inline="true" size="mini" label-suffix=":")
      div.search-box
        el-form-item(label="姓名")
          el-input.inputWidth(v-model="searchForm.name" placeholder="请输入姓名" clearable)
        el-form-item(label="性别")
          el-select.inputWidth(v-model="searchForm.gender" placeholder="请选择性别" clearable)
            el-option(label="男" value="0")
            el-option(label="女" value="1")
        el-form-item(label="会员账号")
          el-input.inputWidth(v-model="searchForm.mobile" placeholder="请输入会员账号" clearable)
        el-form-item(label="调整方式")
          el-select.inputWidth(v-model="searchForm.sourceType" placeholder="请选择调整方式" clearable)
            el-option(label="手动调整" :value="10")
            el-option(label="晋级审核" :value="20")
        el-form-item(label="原级别")
          el-select.inputWidth(v-model="searchForm.beforeLevel" placeholder="请选择原级别" clearable)
            el-option(label="2.0" value="2.0")
            el-option(label="2.5" value="2.5")
            el-option(label="3.0" value="3.0")
            el-option(label="3.5" value="3.5")
            el-option(label="4.0" value="4.0")
            el-option(label="4.5" value="4.5")
        el-form-item(label="调整后级别")
          el-select.inputWidth(v-model="searchForm.afterLevel" placeholder="请选择调整后级别" clearable)
            el-option(label="2.5" value="2.5")
            el-option(label="3.0" value="3.0")
            el-option(label="3.5" value="3.5")
            el-option(label="4.0" value="4.0")
            el-option(label="4.5" value="4.5")
            el-option(label="5.0" value="5.0")
        el-form-item(label="操作人员")
          el-input.inputWidth(v-model="searchForm.updateUserName" placeholder="请输入操作人员" clearable)
        el-form-item(label="操作时间")
          el-date-picker(
            style="width: 300px;"
            v-model="timeRange"
            range-separator="至"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :clearable="false"
          )
      div.search-btn
        el-button(type="primary" @click="exportExcel") 导出列表
        el-button(type="primary" icon="el-icon-search" @click="getDataList") 查 询
    el-table(:data="tableData" v-loading="dataListLoading" border)
      el-table-column(prop="name" header-align="center" align="center" label="姓名")
      el-table-column(prop="gender" header-align="center" align="center" label="性别")
        template(slot-scope="scope")
          font(v-if="scope.row.gender === 0") 男
          font(v-if="scope.row.gender === 1") 女
      el-table-column(prop="mobile" header-align="center" align="center" label="会员账号")
      el-table-column(prop="beforeLevel" header-align="center" align="center" label="原级别")
      el-table-column(prop="afterLevel" header-align="center" align="center" label="调整后级别")
      el-table-column(prop="sourceType" header-align="center" align="center" label="调整方式" )
        template(slot-scope="scope")
          font(v-if="scope.row.sourceType === 10") 手动调整
          font(v-if="scope.row.sourceType === 20") 晋级审核
      el-table-column(prop="updateUserName" header-align="center" align="center" label="操作人员")
      el-table-column(prop="createTime" header-align="center" align="center" label="操作时间")
    el-pagination(
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    )
</template>

<script>
import table from './table.js'

export default {
  name: 'reserveSite-site',
  data () {
    return {
      timeRange: null,
      searchForm: {
        page: 1,
        rows: 10,
        name: '', // 姓名
        gender: '', // 性别
        mobile: '', // 会员账号
        sourceType: '', // 调整方式
        beforeLevel: '', // 原级别
        afterLevel: '', // 调整后级别
        updateUserName: '', // 操作人员
        startTime: '', // 开始时间
        endTime: '' // 结束时间
      },
      dataListLoading: false, // 表格加载中
      tableData: [], // 列表数据
      totalPage: 0, // 总页数
      // 导出报表
      table: {
        columns: table.columns,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      }
    }
  },
  mounted () {
    this.filtertimeRange()
    this.getDataList()
  },
  methods: {
    formatDate (date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    },
    filtertimeRange () {
      const now = new Date()
      const currentDateStr = this.formatDate(now)
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
      const firstDayStr = this.formatDate(firstDay)
      this.timeRange = [firstDayStr, currentDateStr]
    },
    // 列表分页查询
    getDataList () {
      this.dataListLoading = true
      if (!this.timeRange || this.timeRange.length === 0) {
        this.filtertimeRange()
      }
      this.searchForm.startTime = this.timeRange[0]
      this.searchForm.endTime = this.timeRange[1]
      this.$http({
        url: this.$http.adornUrl('/mbMember/queryMbLevelAdjustPage'),
        method: 'post',
        data: this.searchForm
      })
        .then(data => {
          if (data && data.code === 0) {
            this.tableData = data.page.records
            this.totalPage = data.page.total
          } else {
            this.tableData = []
            this.totalPage = 0
          }
          this.dataListLoading = false
        })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.searchForm.rows = val
      this.searchForm.page = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.searchForm.page = val
      this.getDataList()
    },
    // 按照条件查询
    queryList () {
      this.searchForm.page = 1
      this.getDataList()
    },
    //导出报表
    exportExcel () {
      if (!this.timeRange || this.timeRange.length === 0) {
        this.filtertimeRange()
      }
      this.searchForm.startTime = this.timeRange[0]
      this.searchForm.endTime = this.timeRange[1]
      this.$http({
        url: this.$http.adornUrl('/mbMember/queryMbLevelAdjustPage'),
        method: 'post',
        data: {
          ...this.searchForm,
          rows: 100000
        }
      })
        .then(data => {
          if (data && data.code === 0) {
            // 为空判断
            if (data.page.records == null || data.page.records.length === 0) {
              return this.$message.info('没有要导出的数据！')
            }
            // 数据转化
            let exportData = data.page.records
            for (let i of exportData) {
              i.__gender__ = {
                0: '男',
                1: '女'
              }[i.gender]
              i.__sourceType__ = {
                10: '手动调整',
                20: '晋级审核'
              }[i.sourceType]
            }
            // 导出表格
            this.$export.excel({
              columns: this.table.columns,
              data: exportData,
              title: '升级记录报表'
            }).then(() => {
              this.$message.success('升级记录报表导出成功')
            })
          }
        })
    }
  }
}
</script>

<style scoped>
/* 操作三点 菜单样式 */
@import '../../css/opr3dot.css';

.search-box {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}

.search-btn {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
</style>
